export const textLimitation = {
  Array: 350,
  Simple: 700,
  SideBySide: 700,
  FullScreen: 700,
  VTimeline: 350,
  Tabs: 700,
  Narrator: 350,
};
